// src/features/profile/HelpPage.jsx
import React, { useState } from "react";
import "../../../styles/profilepage.css";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/icons/NewLogo.png";
import OverlayHeader from "../../../shared/components/OverlayHeader";

const faqs = [
  {
    q: "What is an AI Therapist?",
    a: (
      <>
        PraSha Sync is your AI-powered mental health companion, built on real
        therapeutic knowledge and guided by experts. It listens with care,
        respects your boundaries, and offers personalized support so you feel
        understood — never judged.
      </>
    ),
  },
  {
    q: "What can PraSha Sync do for me?",
    a: (
      <>
        Share your thoughts by text or voice. PraSha Sync remembers your journey,
        offers gentle insights, and helps you take small, meaningful steps toward
        better well-being — at your own pace.
      </>
    ),
  },
  {
    q: "Who created PraSha Sync?",
    a: (
      <>
        A team of licensed mental health professionals and engineers who believe
        everyone deserves accessible, trustworthy support. Our mission is to
        blend empathy with innovation while putting your well-being first.
      </>
    ),
  },
  {
    q: "Is PraSha Sync a replacement for a Psychologist?",
    a: (
      <>
        No. PraSha Sync doesn’t replace professional care. Think of it as a
        supportive companion when your therapist isn’t available. If you’re
        struggling or need deeper support, please connect with a licensed
        therapist. <br />
        <strong>⚠️ If you are in crisis, call 988 (U.S.) or your local emergency line.</strong>
      </>
    ),
  },
  {
    q: "Who can use PraSha Sync?",
    a: (
      <>
        Adults (18+) seeking thoughtful, judgment-free support for stress,
        anxiety, life transitions, or relationship challenges.
      </>
    ),
  },
  {
    q: "Is it really safe and private?",
    a: (
      <ul>
        <li>Conversations are strictly confidential.</li>
        <li>Nothing is shared without your consent.</li>
        <li>Features are developed with guidance from mental health experts.</li>
      </ul>
    ),
  },
  {
    q: "Does it cost anything?",
    a: (
      <>
        Getting started is free. Our mission is to make mental wellness
        accessible to everyone.
      </>
    ),
  },
  {
    q: "How is PraSha Sync different from other AI chatbots?",
    a: (
      <>
        It’s purpose-built for mental health, trained on therapeutic data,
        reviewed by experts, and designed with clear boundaries so you feel
        supported — not just “chatted at.”
      </>
    ),
  },
  {
    q: "Who supervises the AI’s guidance?",
    a: (
      <>
        Licensed mental health professionals guide and review the system to keep
        support responsible and rooted in real therapeutic practices.
      </>
    ),
  },
  {
    q: "Will PraSha Sync share my data with anyone?",
    a: (
      <>
        No. We will never sell or share your personal conversations. Your trust
        is foundational, and protecting your privacy is non-negotiable.
      </>
    ),
  },
  {
    q: "What makes PraSha Sync trustworthy?",
    a: (
      <ul>
        <li>Expert involvement: input from psychologists and mental health pros.</li>
        <li>Privacy first: your data is secure and confidential.</li>
        <li>Transparency: clear about what the AI can and cannot do.</li>
        <li>Mission-driven: built to support your mental wellness with care.</li>
      </ul>
    ),
  },
  {
    q: "How do I contact support?",
    a: (
      <>
        Can’t find what you need? Email{" "}
        <a href="mailto:support@prashasync.io">support@prashasync.io</a>. We’ll
        help with care and confidentiality.
      </>
    ),
  },
];

export default function HelpPanel({ onClose }) {
  const navigate = useNavigate();
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleFAQ = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  return (
    <div className="help-container">
       <OverlayHeader onBack={onClose} />
      {/* Header 
      <div className="help-header">
        <button className="help-back-button" onClick={() => navigate(-1)}>
          <IoIosArrowBack size={18} />
          <span></span>
        </button>
        <img src={logo} alt="Logo" className="archived-logo" />
      </div>*/}

      <div className="help-content">
        <h3 className="faq-title"> FAQ's</h3>

        {faqs.map((item, index) => {
          const isOpen = expandedIndex === index;
          return (
            <div
              key={index}
              className="faq-box"
              onClick={() => toggleFAQ(index)}
              aria-expanded={isOpen}
              
              style={{
                display: "grid",
                gridTemplateColumns: "1fr auto",
                rowGap: 8,
              }}
            >
              <span className="faq-question-text">
                {index + 1}. {item.q}
              </span>
              <span className="faq-plus">{isOpen ? "−" : "+"}</span>

              {isOpen && (
                <div className="faq-answer" style={{ gridColumn: "1 / -1" }}>
                  {item.a}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}


